import React from "react";
import { GridItem, GridContainer } from "./MerchantAndTerminals.styles";
import TextField from "../../textField/TextField";
import { useSelector } from "react-redux";
import CriptoWallets from "../../wallets/CriptoWallets";

const BankFields = ({
  formValues,
  handleChange,
  handleBlur,
  errors,
  touched,
  readOnly = false,
}) => {
  const {
    acquirer: { currency },
    bank: { account_number, address, routing_number, Iban, Bid },
  } = formValues;

  const { formType } = useSelector((state) => state.merchantAndTerminals);

  const accountNumberFieldLabel = (currency = "USD") => {
    if (currency === "MXN") {
      return "CLABE";
    }
    return "Account Number";
  };

  const accountNumberFieldHelpText = (currency = "USD") => {
    if (currency === "MXN") {
      return "CLABE";
    }
    return "Bank account number";
  };

  const handleNumericFieldChange = (event) => {
    const { name, value } = event.target;
    const sanitizedValue = value.replace(/\D/g, "");

    handleChange({
      target: {
        name,
        value: sanitizedValue,
      },
    });
  };

  return (
    <GridContainer>
      <GridItem xs={12} md={6} lg={3} padding="15px 15px 15px 0">
        <TextField
          id={"bank.Iban"}
          name="bank.Iban"
          fullWidth
          label="Bank Name"
          value={
            formType === "createEnrollment" || formType === "editTerminal"
              ? Iban
              : Bid
          }
          onChange={handleChange}
          onBlur={handleBlur}
          required
          error={errors.bank?.Iban}
          touched={touched.bank?.Iban}
          disabled={readOnly}
        />
      </GridItem>
      <GridItem xs={12} md={6} lg={3} padding="15px 15px 15px 0">
        <TextField
          id="bank.address"
          name="bank.address"
          fullWidth
          label="Address / Branch"
          value={address}
          onChange={handleChange}
          onBlur={handleBlur}
          required
          maxLength={32}
          error={errors.bank?.address}
          touched={touched.bank?.address}
          disabled={readOnly}
          helperText="Bank address / branch"
        />
      </GridItem>
      <GridItem xs={12} md={6} lg={3} padding="15px 15px 15px 0">
        <TextField
          id="bank.account_number"
          name="bank.account_number"
          fullWidth
          label={accountNumberFieldLabel(currency)}
          value={account_number}
          onChange={handleNumericFieldChange}
          onBlur={handleBlur}
          required
          maxLength={30}
          inputProps={{
            inputMode: "numeric",
            pattern: "[0-9]*",
          }}
          error={errors.bank?.account_number}
          touched={touched.bank?.account_number}
          disabled={readOnly}
          helperText={accountNumberFieldHelpText(currency)}
        />
      </GridItem>
      {currency !== "MXN" && (
        <GridItem xs={12} md={6} lg={3} padding="15px 15px 15px 0">
          <TextField
            id="bank.routing_number"
            name="bank.routing_number"
            fullWidth
            label="Routing Number"
            value={routing_number}
            onChange={handleNumericFieldChange}
            onBlur={handleBlur}
            required
            maxLength={12}
            inputProps={{
              inputMode: "numeric",
              pattern: "[0-9]*",
            }}
            error={errors.bank?.routing_number}
            touched={touched.bank?.routing_number}
            disabled={readOnly}
            helperText="Bank routing number"
          />
        </GridItem>
      )}
      <GridItem xs={12} padding="15px 15px 15px 0">
        <CriptoWallets
          formValues={formValues}
          handleChange={handleChange}
          errors={errors}
          touched={touched}
          readOnly={readOnly}
        />
      </GridItem>
    </GridContainer>
  );
};

export default BankFields;
